// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AddFindingPopup_content_container__MhifC {
}

/* upload section */
.AddFindingPopup_upload_container__ffYL5 {
  display: flex;
  margin: 10px 0px;
}

.AddFindingPopup_image_box__o6xQa {
  width: 175px;
  height: 120px;
  border: 1px solid var(--color-theme-silver);
  margin: 0px 10px 10px 0px;
  border-radius: 2px;
  overflow: scroll;
}

.AddFindingPopup_image__BCn3O {
  width: 100%;
  object-fit: cover;
}

.AddFindingPopup_upload_actions_container__XMVJP {
  display: flex;
  flex-direction: column;
}

.AddFindingPopup_upload_label__tuRfk {
  border: 1px solid var(--color-theme-blue);
  border-radius: 15px;
  padding: 2px 9px;
  cursor: pointer;
  margin: 5px;
  text-align: center;
  color: var(--color-theme-blue);
}

.AddFindingPopup_upload_label__tuRfk:hover {
  background-color: var(--color-theme-lightblue);
}

.AddFindingPopup_upload_input__NQUrQ {
  display: none;
}

.AddFindingPopup_upload_btn__PDs8Y {
  width: 120px;
  height: 28px;
  font-weight: bold !important;
  color: var(--color-theme-10) !important;
  background-color: var(--color-theme-silver) !important;
  margin: 5px !important;
}

.AddFindingPopup_delete_icon__IY0YG {
  margin: 5px;
  cursor: pointer;
}
/* upload section */

.AddFindingPopup_finding_col__SstbO {
  padding: 15px 0px 0px 0px;
}

.AddFindingPopup_artist_agency_row__IJqSi {
  display: flex;
}

.AddFindingPopup_error_container__qoIJW {
  padding: 10px;
  margin: 0px 5px 25px 5px;
  background-color: var(--color-theme-red);
}

.AddFindingPopup_error_text__6fWuL {
  font-size: 16px;
  color: var(--color-theme-white);
}

.AddFindingPopup_input_row__kkc12 {
  margin-right: 10px !important;
}

.AddFindingPopup_requiredRed__d3KhI {
  color: var(--color-font-red);
}
`, "",{"version":3,"sources":["webpack://./src/@_components/popups/AddFindingPopup/AddFindingPopup.module.css"],"names":[],"mappings":"AAAA;AACA;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,2CAA2C;EAC3C,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,yCAAyC;EACzC,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,WAAW;EACX,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,4BAA4B;EAC5B,uCAAuC;EACvC,sDAAsD;EACtD,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;AACA,mBAAmB;;AAEnB;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,wBAAwB;EACxB,wCAAwC;AAC1C;;AAEA;EACE,eAAe;EACf,+BAA+B;AACjC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,4BAA4B;AAC9B","sourcesContent":[".content_container {\n}\n\n/* upload section */\n.upload_container {\n  display: flex;\n  margin: 10px 0px;\n}\n\n.image_box {\n  width: 175px;\n  height: 120px;\n  border: 1px solid var(--color-theme-silver);\n  margin: 0px 10px 10px 0px;\n  border-radius: 2px;\n  overflow: scroll;\n}\n\n.image {\n  width: 100%;\n  object-fit: cover;\n}\n\n.upload_actions_container {\n  display: flex;\n  flex-direction: column;\n}\n\n.upload_label {\n  border: 1px solid var(--color-theme-blue);\n  border-radius: 15px;\n  padding: 2px 9px;\n  cursor: pointer;\n  margin: 5px;\n  text-align: center;\n  color: var(--color-theme-blue);\n}\n\n.upload_label:hover {\n  background-color: var(--color-theme-lightblue);\n}\n\n.upload_input {\n  display: none;\n}\n\n.upload_btn {\n  width: 120px;\n  height: 28px;\n  font-weight: bold !important;\n  color: var(--color-theme-10) !important;\n  background-color: var(--color-theme-silver) !important;\n  margin: 5px !important;\n}\n\n.delete_icon {\n  margin: 5px;\n  cursor: pointer;\n}\n/* upload section */\n\n.finding_col {\n  padding: 15px 0px 0px 0px;\n}\n\n.artist_agency_row {\n  display: flex;\n}\n\n.error_container {\n  padding: 10px;\n  margin: 0px 5px 25px 5px;\n  background-color: var(--color-theme-red);\n}\n\n.error_text {\n  font-size: 16px;\n  color: var(--color-theme-white);\n}\n\n.input_row {\n  margin-right: 10px !important;\n}\n\n.requiredRed {\n  color: var(--color-font-red);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"content_container": `AddFindingPopup_content_container__MhifC`,
	"upload_container": `AddFindingPopup_upload_container__ffYL5`,
	"image_box": `AddFindingPopup_image_box__o6xQa`,
	"image": `AddFindingPopup_image__BCn3O`,
	"upload_actions_container": `AddFindingPopup_upload_actions_container__XMVJP`,
	"upload_label": `AddFindingPopup_upload_label__tuRfk`,
	"upload_input": `AddFindingPopup_upload_input__NQUrQ`,
	"upload_btn": `AddFindingPopup_upload_btn__PDs8Y`,
	"delete_icon": `AddFindingPopup_delete_icon__IY0YG`,
	"finding_col": `AddFindingPopup_finding_col__SstbO`,
	"artist_agency_row": `AddFindingPopup_artist_agency_row__IJqSi`,
	"error_container": `AddFindingPopup_error_container__qoIJW`,
	"error_text": `AddFindingPopup_error_text__6fWuL`,
	"input_row": `AddFindingPopup_input_row__kkc12`,
	"requiredRed": `AddFindingPopup_requiredRed__d3KhI`
};
export default ___CSS_LOADER_EXPORT___;
